/** @returns {'test'|'live'|null} */
export const getStripeKeyMode = (key) => {
  if (!key || typeof key !== 'string') return null;
  const trimmed = key.trim();
  if (trimmed.startsWith('pk_live_') || trimmed.startsWith('sk_live_')) return 'live';
  if (trimmed.startsWith('pk_test_') || trimmed.startsWith('sk_test_')) return 'test';
  return null;
};

export const stripeModesMatch = (publishableKey, apiMode) => {
  const frontendMode = getStripeKeyMode(publishableKey);
  if (!frontendMode || !apiMode) return true;
  return frontendMode === apiMode;
};

export const stripeModeMismatchMessage =
  'Stripe is misconfigured on the server. In vendor-booking-api/.env, STRIPE_KEY and STRIPE_SECRET must both be test or both be live.';

export const isMissingPaymentIntentError = (message) =>
  typeof message === 'string' &&
  /no such payment_intent/i.test(message);

export const missingPaymentIntentHelpMessage =
  'The payment session could not be found. This usually means Stripe keys were changed while checkout was open. Close this dialog and try again, or ask your administrator to verify STRIPE_KEY and STRIPE_SECRET in vendor-booking-api/.env.';
